import Icon from '@components/common/Icon';
import ImageCard from '@components/common/ImageCard';
import { DATA_BASE_URL } from '@lib/constants';

const stats = [
  { label: 'Local, National and International Competitions', value: '15+' },
  { label: 'Team Members Mentored', value: '50+' },
  { label: 'Years of Experience', value: '4+' },
  { label: 'Awards Won', value: '10+' }
];

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden py-20 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8">
      {/* Gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom right, var(--color-theme-1), var(--color-theme-2))'
        }}
      >
        {/* Ambient shapes */}
        <div
          className="absolute top-0 -left-4 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-20"
          style={{ backgroundColor: 'var(--color-accent-2)' }}
        ></div>
        <div
          className="absolute -bottom-8 right-0 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-10"
          style={{ backgroundColor: 'var(--color-accent-3)' }}
        ></div>
      </div>

      <div className="container mx-auto relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Team Photo */}
          <div className="flex justify-center order-2 md:order-1">
            <div className="relative">
              <div
                className="relative rounded-2xl p-1.5 shadow-card-hover"
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  borderColor: 'var(--color-border-light)',
                  borderWidth: '1px',
                  borderStyle: 'solid'
                }}
              >
                <ImageCard
                  src={`${DATA_BASE_URL}/data/robotics/images/team_photo_2025_oct.webp`}
                  alt="Robotics Team October 2025"
                  aspectRatio="aspect-square"
                  className="w-80 h-80 rounded-xl"
                />
              </div>
              {/* Floating icon badge */}
              <div
                className="absolute -top-4 -right-4 w-20 h-20 rounded-2xl flex items-center justify-center shadow-card-hover"
                style={{ backgroundColor: 'var(--color-accent-6)' }}
              >
                <Icon name="robotics" size="xl" className="text-white" />
              </div>
            </div>
          </div>

          {/* Hero Content */}
          <div className="text-left order-1 md:order-2 space-y-6 sm:space-y-8">
            <div className="space-y-3 sm:space-y-4">
              <div
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs sm:text-sm font-medium"
                style={{
                  backgroundColor: 'var(--color-theme-2)',
                  color: 'var(--color-accent-7)'
                }}
              >
                <Icon name="robotics" size="sm" className="sm:hidden" />
                <Icon name="robotics" size="md" className="hidden sm:block" />
                <span>Team Captain & Founding Partner</span>
              </div>
              <h1
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-extrabold tracking-tight"
                style={{ color: 'var(--color-heading)' }}
              >
                Robotics Journey
              </h1>
              <p
                className="text-lg sm:text-xl md:text-2xl font-semibold"
                style={{ color: 'var(--color-subheading)' }}
              >
                Building the Future, One Robot at a Time
              </p>
            </div>

            <p
              className="text-base sm:text-lg leading-relaxed max-w-2xl"
              style={{ color: 'var(--color-subtle)' }}
            >
              As a founding partner of the Philippines' first FRC team and VEX robotics captain,
              I've led teams through 15+ local, national, and international competitions, pioneered autonomous systems,
              and mentored the next generation of engineers. From Grade 9 to now, robotics has been
              my platform for innovation, leadership, and making an impact.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-3 sm:gap-4 pt-2 sm:pt-4">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="rounded-xl p-3 sm:p-4 text-center"
                  style={{
                    backgroundColor: 'var(--color-card-bg)',
                    borderColor: 'var(--color-border-light)',
                    borderWidth: '1px',
                    borderStyle: 'solid'
                  }}
                >
                  <div
                    className="text-2xl sm:text-3xl md:text-4xl font-bold mb-1"
                    style={{ color: 'var(--color-accent-7)' }}
                  >
                    {stat.value}
                  </div>
                  <div
                    className="text-xs sm:text-sm font-medium"
                    style={{ color: 'var(--color-muted)' }}
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
